<template>
  <div class="relative flex flex-col border-t-2 pt-4">
    <div v-if="autoPollError">
      <div class="flex flex-col gap-4">
        <div class="bg-red-200 rounded-sm text-gray-600 p-2">
          Error Loading Existing Tasks
        </div>
        <Button class="p-2"
          color="gray"
          @click="initiateRoutePullListPolling">
          Retry
        </Button>
      </div>
    </div>
    <div v-else>
      <div class="absolute right-2 top-2 flex-row">
        <button class="px-1 rounded-sm text-sm font-italic text-gray-400 bg-gray-200 hover:bg-gray-300"
          @click="getRoutePullList">
          Refresh
        </button>
      </div>
      <div class="p-2 bg-gray-50 rounded-md">
        <div class="flex flex-col bg-gray-100 p-2 rounded-md shadow-md">
          <div class="text-gray-400"
            v-if="routePullListDataEmpty">
            No Existing Route Pull Tasks
          </div>
          <div class="grid grid-cols-9 gap-2 font-bold px-2"
            v-else>
            <span>Type</span>
            <span>Created At</span>
            <span>Completed At</span>
            <span class="col-span-2">Status</span>
            <span>Date</span>
            <span>Partitions</span>
            <span class="col-span-2">Options</span>
          </div>
          <div class="flex flex-col gap-2"
            v-for="routePullEntry in routePullListEntries"
            :key="routePullEntry.id">
            <div class="flex flex-row gap-2 items-center shadow-md rounded-md">
              <RoutePullTaskContentSimple
                :routePullEntry="routePullEntry"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'

import Button from '../../Button.vue'
import RoutePullTaskContentSimple from './RoutePullTaskContentSimple.vue';

import user from '../../../services/user/user.js'
import routePullService from '../../../services/activeSync/routePull.js'

export default {
  components: {
    Button,
    RoutePullTaskContentSimple,
  },
  props: {},
  data() {
    return {
      routePullListEntries: undefined,

      intervalId: undefined,
      allowFastPoll: false,
      autoPollError: false,

      quickTimeoutSet: false,

      slowPoll: 30, // seconds
    }
  },
  methods: {
    initiateRoutePullListPolling() {
      this.autoPollError = false
      if (!this.intervalId) {
        this.getRoutePullList()
        this.intervalId = setInterval(() => {
          this.getRoutePullList()
        }, this.slowPoll * 1000)
      }
    },
    clearPolling() {
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = undefined
      }
    },
    async getRoutePullList() {
      try {
        this.routePullListEntries = await routePullService.getRoutePullList()
        if (!this.allowFastPoll) {
          return
        }

        if (this.anyRunningOrPending(this.routePullListEntries)) {
          if (!this.quickTimeoutSet) {
            setTimeout(() => {
              this.quickTimeoutSet = false
              this.getRoutePullList()
            }, 3 * 1000)
            this.quickTimeoutSet = true
          }
        }
      }
      catch (error) {
        this.autoPollError = true
        this.clearPolling()
      }
    },
    anyRunningOrPending(routePullListEntries) {
      for (const routePullListEntry of routePullListEntries) {
        if (routePullListEntry.status !== 'complete' && routePullListEntry.status !== 'error') {
          return true
        }
      }
      return false
    },
  },
  async mounted() {
    this.allowFastPoll = true
    this.autoPollError = false
    await user.ready()

    this.initiateRoutePullListPolling()
  },
  //beforeUnmount() {
  // eslint-disable-next-line
  beforeDestroy() {
    this.allowFastPoll = false
    this.clearPolling()
  },
  computed: {
    routePullListDataEmpty() {
      return isEmpty(this.routePullListEntries)
    }
  }
}
</script>
